import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-otds-error-root',
  templateUrl: './otds-error-root.component.html',
  styleUrls: ['./otds-error-root.component.scss']
})
export class OtdsErrorRootComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
